import { z } from "zod";
import { VALIDATION_MESSAGES_CARD, allowedSpecialCharsRegex } from "constants/validations";

// First Name Schema
export const firstNameSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .max(20, { message: "Maximum 20 characters" })
    .regex(allowedSpecialCharsRegex, { message: "Contains invalid characters" });

export const optionalFirstNameSchema = z.union([z.literal(""), firstNameSchema]).optional();
